import { forwardRef } from 'react'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@cocoonspace/ui/components/select'
import { useLingui } from '@lingui/react/macro'

const formatDurationLabel = (minutes: number): string => {
	if (minutes === 30) {
		return '30min'
	}
	const hours = Math.floor(minutes / 60)
	const remainingMinutes = minutes % 60
	if (remainingMinutes === 0) {
		return `${hours}h`
	}
	return `${hours}h${remainingMinutes}`
}

const meetingBuffers = Array.from({ length: 6 }, (_, i) => {
	const minutes = (i + 1) * 30
	return {
		label: formatDurationLabel(minutes),
		value: minutes,
	}
})

export const MeetingBufferSelect = forwardRef<
	HTMLButtonElement,
	{
		value?: number
		onChange: (value?: number) => void
	}
>(({ value, onChange }, ref) => {
	const { t } = useLingui()

	return (
		<Select
			onValueChange={(value) => onChange(value ? Number(value) : undefined)}
			value={value?.toString()}
		>
			<SelectTrigger
				ref={ref}
				inputSize='sm'
			>
				<SelectValue placeholder={t`Sélectionner`} />
			</SelectTrigger>

			<SelectContent onWheel={(e) => e.stopPropagation()}>
				<SelectItem value='0'>{t`Aucun`}</SelectItem>
				{meetingBuffers.map((buffer) => (
					<SelectItem
						key={buffer.value}
						value={buffer.value.toString()}
					>
						{buffer.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	)
})
